import React, { useState } from 'react';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const CHtmlToOutput = React.forwardRef((props, ref) => {
    const generatePDF = async () => {
        const inputs = props.targets || [ref.current];
        if (!inputs) return;

        console.debug(inputs);


        // Création du PDF
        var pdf;
        if (props.outputType === "pdf") {
            pdf = new jsPDF(props.pdfOrientation, props.pdfUnit, props.pdfFormat, props.pdfCompression);
        }


        var pageWidth = props.width;
        var pageHeight = props.height;
        var landscapeMode = (props.pdfOrientation === "l" || props.pdfOrientation === "landscape");
        if (landscapeMode) {
            pageWidth = props.height;
            pageHeight = props.width;
        }

        var currY = props.y;
        // Capture la section complète
        var output = [];


        const manageCanvas = (canvas) => {
            const imgData = canvas.toDataURL(props.type, props.quality);

            output.push(imgData);
            if (props.outputType === "pdf") {
                var imgWidth = canvas.width;
                var imgHeight = canvas.height;

                /*imgWidth = pageWidth;
                imgHeight = (canvas.height * imgWidth) / canvas.width;*/

                if (props.typeSize === "page") {
                    if (landscapeMode) {
                        imgHeight = props.width - props.y;
                        imgWidth = props.height - props.x;//(canvas.width * imgHeight) / canvas.height
                    }
                    else {
                        imgWidth = props.width - props.x;
                        imgHeight = props.height - props.y;//(canvas.height * imgWidth) / canvas.width; >> Conserve le format de l'image ???
                    }
                }
                else {
                    var width;
                    if (landscapeMode) {
                        width = document.getElementsByClassName("content")[0].clientWidth;
                        //var height = document.getElementsByClassName("content")[0].clientHeight;
                        imgWidth = (canvas.width * pageWidth) / width;
                        if (imgWidth > pageWidth) imgWidth = pageWidth;
                        //imgHeight = (canvas.height * props.height) / height;
                        imgHeight = (canvas.height * imgWidth) / canvas.width;
                        if (imgHeight > pageHeight) {
                            imgHeight = pageHeight;
                            imgWidth = (canvas.width * imgHeight) / canvas.height;
                        }

                        //imgHeight = props.width - props.y;
                        //imgWidth = (canvas.width * imgHeight) / canvas.height;
                    }
                    else {
                        width = document.getElementsByClassName("content")[0].clientWidth;
                        //var height = document.getElementsByClassName("content")[0].clientHeight;
                        imgWidth = (canvas.width * pageWidth) / width;
                        if (imgWidth > pageWidth) imgWidth = pageWidth;
                        //imgHeight = (canvas.height * pageHeight) / height;
                        imgHeight = (canvas.height * imgWidth) / canvas.width;
                        if (imgHeight > pageHeight) {
                            imgHeight = pageHeight;
                            imgWidth = (canvas.width * imgHeight) / canvas.height;
                        }


                        //imgWidth = props.width - props.x;
                        //imgHeight = (canvas.height * imgWidth) / canvas.width;
                    }
                }

                if (imgWidth > 0 && imgHeight > 0) {
                    var tempY = currY + imgHeight;
                    //pdf = pdf.moveTo(props.x, currY);
                    if (tempY > pageHeight) {
                        currY = props.y;//Reset cursor position
                        pdf = pdf.addPage();
                        pdf = pdf.movePage(pdf.getNumberOfPages());
                    }
                    var coeffWidth = props.coeffWidth || props.coeff;
                    var coeffHeight = props.coeffHeight || props.coeff;
                    imgWidth = coeffWidth * imgWidth;
                    imgHeight = coeffHeight * imgHeight;

                    pdf.addImage(imgData, props.format, props.x, currY, imgWidth, imgHeight, props.alias, props.compression, props.rotation);
                    currY += imgHeight;
                    pdf = pdf.moveTo(props.x, currY);
                }
            }
        };



        if (props.isWaiting) {
            for (let i = 0; i < inputs.length; i++) {
                var input = inputs[i];

                var isHidden = input.classList.contains("d-none");
                if (isHidden) input.classList.remove("d-none");
                const canvas = await html2canvas(input, props.options); // Meilleure qualité
                if (isHidden) input.classList.add("d-none");

                manageCanvas(canvas);
            }

            if (pdf != null) {
                pdf.save(props.name);
                output = pdf;
            }

            if (props.callback) props.callback(output);
        }
        else {

            var asyncJobs = inputs.map(async (input) => {
                return await new Promise(async (resolve, reject) => {
                    var isHidden = input.classList.contains("d-none");
                    if (isHidden) input.classList.remove("d-none");
                    const canvas = await html2canvas(input, props.options); // Meilleure qualité
                    if (isHidden) input.classList.add("d-none");

                    manageCanvas(canvas);
                    resolve();
                });
            });
            Promise.all(asyncJobs).then(results => {
                if (pdf != null) {
                    pdf.save(props.name);
                    output = pdf;
                }

                if (props.callback) props.callback(output);
            });
        }
    };

    React.useEffect(() => {
        generatePDF();
    }, []);
    return <div ref={ref}>{props.children}</div>;
});

// Setting default values for the props of CHtmlToOutput
CHtmlToOutput.defaultProps = {
    //compression: "NONE",//"NONE" | "FAST" | "MEDIUM" | "SLOW"
    name: "print.pdf",
    format: "PNG",
    type: "image/png",
    //quality: 1,//1 à 0
    options: { scale: 2 },
    pdfOrientation: "portrait",
    pdfUnit: "mm",
    pdfFormat: "a4",
    pdfCompression: false,
    width: 210, // Largeur A4 en mm
    height: 297, // Hauteur A4 en mm
    x: 0,
    y: 10,
    coeff: 1
};

export default CHtmlToOutput;